export default class EpisodeBrowsingRetentionRate {
  constructor(public retentionRate: number, public commandIndex: number) {}
}
